import { useState, useEffect } from "react";

/**
 * Custom hook to fetch images with a fake API call
 * Simulates a real-time scenario with async loading
 * @returns {Object} images array and loading state
 */
export const usePreviewImages = () => {
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Simulate API call with delay
        const fetchImages = async () => {
            setLoading(true);        
            // Simulated API response
            const fetchedImages = [
                "https://spyne-media.s3.amazonaws.com/2025-12-15/car_replace_bg_cdbc937e-128b-4d01-a5b0-6810fcac8d6b.png",
                "https://spyne-media.s3.amazonaws.com/2025-12-15/car_replace_bg_49378824-fa1b-41b9-a647-b00eb68a3797.png",
                "https://spyne-media.s3.amazonaws.com/2025-12-15/car_replace_bg_ae568e74-1b1f-40da-b22a-c9e7eae7a538.png",
                "https://spyne-media.s3.amazonaws.com/2025-12-15/car_replace_bg_f9a60c6a-748d-4323-ae22-98e49a73f982.png",
                "https://spyne-media.s3.amazonaws.com/2025-12-15/car_replace_bg_4fa5c879-6ffe-4f6d-8eb0-438a02d931ed.png",
                "https://spyne-media.s3.amazonaws.com/2025-12-15/car_replace_bg_49378824-fa1b-41b9-a647-b00eb68a3797.png",
               
            ];
            setImages(fetchedImages);
            setLoading(false);
        };

        fetchImages();
    }, []);

    return { images, loading };
};

